/**
 * Build the "Shop the Edit" URL, forwarding any incoming campaign params.
 *
 * If the current URL carries UTM/campaign params, all of them are forwarded to
 * the destination so attribution is preserved. Otherwise a default campaign is
 * applied.
 *
 * @returns {string} Destination URL for the Shop the Edit CTA
 */
export function buildShopUrl() {
  const baseUrl = 'https://www.mytheresa.com/to/women/edits/the-maison-mytheresa-edit';
  const currentParams = new URLSearchParams(window.location.search);

  // Check if any UTM/campaign params exist in current URL
  const hasCampaignParams = currentParams.has('utm_source') ||
                            currentParams.has('utm_campaign') ||
                            currentParams.has('utm_medium');

  if (hasCampaignParams) {
    // Forward ALL incoming params to destination URL
    const targetUrl = new URL(baseUrl);
    for (const [key, value] of currentParams) {
      targetUrl.searchParams.set(key, value);
    }
    return targetUrl.toString();
  }

  // Use default campaign params when no campaign params present
  return `${baseUrl}?utm_source=yacht&utm_campaign=maison-yacht-2026`;
}

export default buildShopUrl;
